import type { AssetIndexBySequenceNumber } from '@/lib/portfolio-navigation';

type GetCurrentAssetPageNumberOptions = {
  asset_index_by_sequence_number: AssetIndexBySequenceNumber;
  current_asset_sequence_number: number;
};

export function get_current_asset_page_number({
  asset_index_by_sequence_number,
  current_asset_sequence_number,
}: GetCurrentAssetPageNumberOptions) {
  const current_asset_index = asset_index_by_sequence_number.get(
    current_asset_sequence_number,
  );

  if (current_asset_index === undefined) {
    return 1;
  }

  return current_asset_index + 1;
}

export function get_total_asset_page_count(
  asset_resources: readonly unknown[],
) {
  return asset_resources.length;
}
